<script>
import Validation from '@/plugins/validation'
import { Input, AutocompleteSelect } from '@/components/formelements'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Campaigns',
  data() {
    return {
      ...Validation,
      items: [
        {
          text: 'GridListingElement',
          value: 'GetProfanityExceptionGridListingElement',
          update: 'UpdateProfanityStatusGridListingElement'
        },
        {
          text: 'GridListingOffer',
          value: 'GetProfanityExceptionGridListingOffer',
          update: 'UpdateProfanityStatusGridListingOffer'
        },
        {
          text: 'Listing',
          value: 'GetProfanityExceptionListing',
          update: 'UpdateProfanityStatusListing'
        },
        {
          text: 'ListingLink',
          value: 'GetProfanityExceptionListingLink',
          update: 'UpdateProfanityStatusListingLink'
        },
        {
          text: 'RetailerPromotionPageMapArea',
          value: 'GetProfanityExceptionRetailerPromotionPageMapArea',
          update: 'UpdateProfanityStatusRetailerPromotionPageMapArea'
        },
        {
          text: 'Store',
          value: 'GetProfanityExceptionStore',
          update: 'UpdateProfanityStatusStore'
        },
      ],
      dialog: false,
      newProfanity: false,
      currentlyShowing: {}
    }
  },
  async mounted(){
    await this.$store.dispatch('profanityManager/GET_PROFANITY_LIST')
    await this.$store.dispatch('profanityManager/GET_PROFANITY_QUEUE')
  },
  components: {
    Input,
    AutocompleteSelect,
  },
  computed: {
    ...mapState({
      status: state => state.profanityManager.status,
      profanityException: state => state.profanityManager.profanityException,
    }),
    ...mapGetters({
      profanityList: 'profanityManager/profanityList',
      queueList: 'profanityManager/queueList',
    }),
    queueItems() {
      return this.queueList.map( queueItem => {
        let objValue = this.items.find(item => item.text == queueItem.queueName)
        return { text: queueItem.text, value: objValue.value }
      })
    }
  },
  watch: {
    status: async function(){
      this.currentlyShowing = this.items.find(item => item.value == this.status)
      await this.$store.dispatch('profanityManager/GET_PROFANITY_EXCEPTION')
    },
  },
  methods: {
    profanityHeaders() {
      return [
        {
          text: 'ID',
          value: 'value'
        },
        {
          text: 'Word',
          value: 'text'
        },
        {
          text: 'Actions',
          value: 'Actions'
        }
      ]
    },
    headers() {
      return [
        {
          text: 'Merchant ID',
          value: 'MerchantID'
        },
        {
          text: 'Listing ID',
          value: 'ListingID'
        },
        {
          text: 'Field',
          value: 'ProfanityMatchTypeDescription'
        },
        {
          text: 'Field Value',
          value: 'ColumnValue'
        },
        {
          text: 'Action',
          value: 'Actions'
        },
      ]
    },
    editProfanity(item){
      this.$store.dispatch('profanityManager/SET_PROFANITY_EDITING', item)
    },
    async saveProfanity(item){
      if (this.$refs.editBillingForm.validate()){
        await this.$store.dispatch('profanityManager/UPDATE_PROFANITY', { word: this.$store.state.profanityManager.editProfanity ,profanityID: item.value, status: 1})
      }
    },
    async deleteProfanity(item){
      await this.$store.dispatch('profanityManager/UPDATE_PROFANITY', { word: item.text ,profanityID: item.value, status: 901})
    },
    async addNewProfanity(){
      if (this.$refs.newProfanityForm.validate()){
        await this.$store.dispatch('profanityManager/INSERT_PROFANITY')
        await this.$store.dispatch('profanityManager/GET_PROFANITY_LIST')
        this.newProfanity = false
      }
    },
    async allowProfanity(item){
      const data = {
        profanityMatchTypeId: item.ProfanityMatchTypeID,
        listingId: item.ListingID,
        profanityOverride: 'Y',
        merchantId: item.MerchantID,
        gridListingElementId: item.GridListingElementID,
        gridListingId: item.GridListingID,
        gridListingOfferId: item.GridListingOfferID,
        storeId: item.StoreID,
        listingLinkID: item.ListingLinkID,
        retailerPromotionPageMapAreaID: item.RetailerPromotionPageMapAreaID,
        promotionCode: item.PromotionCode,
        retailerId: item.RetailerID
      }
      await this.$store.dispatch('profanityManager/UPDATE_PROFANITY_STATUS', { endpoint: this.currentlyShowing.update, data})
    }
  }
}
</script>

<template>
  <v-container fluid>
    <v-row justify="space-between">
      <v-col cols="12" sm="6" >
        <AutocompleteSelect form="profanityManager" field="status" placeholder="" label="Select a Queue" :items="queueItems" />
      </v-col>
      <v-col class="mr-2" cols="12" md="3" >
        <v-btn color="primary" @click="dialog = true"><v-icon left>mdi-minus-circle</v-icon>Manage Profanity List</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-data-table
            :headers="headers()"
            :items="profanityException"
            :items-per-page="10"
          >
            <template v-slot:item.Actions="{ item }" >
              <span>
                <v-btn icon @click="allowProfanity(item)" color="primary">
                  <v-tooltip top color="primary">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="px-1"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-account-check
                      </v-icon>
                    </template>
                    <span>Allow</span>
                  </v-tooltip>
                </v-btn>
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="dialog" width="700">
      <v-card>
        <v-card-title class="primary--text">
          Profanity Manager <v-spacer></v-spacer> <v-icon @click="newProfanity = !newProfanity" color="primary" x-large>mdi-plus-circle</v-icon>
        </v-card-title>
        <v-card-text class="py-0" v-if="newProfanity">
          <v-form ref="newProfanityForm">
            <v-row class="d-flex justify-end">
              <v-col class="py-0" cols="12" sm="4">
                <Input dense form="profanityManager" field="newProfanity" :rules="[...required]" :maxlength="128" placeholder="" label="New Profanity Word" />
              </v-col>
              <v-col class="py-0" cols="12" sm="3">
                <v-btn width="100%" color="primary" @click="addNewProfanity"><v-icon left>mdi-content-save</v-icon>Save</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-text>
          <v-data-table
            :headers="profanityHeaders()"
            :items="profanityList"
          >
            <template v-slot:item.text="{ item }" >
              <span v-if="!item.editing">
                {{ item.text }}
              </span>
              <span v-else>
                <v-form ref="editBillingForm" class="pt-5">
                  <Input dense form="profanityManager" field="editProfanity" :rules="[...required]" :maxlength="128" placeholder="" label="" />
                </v-form>
              </span>
            </template>
            <template v-slot:item.Actions="{ item }" >
              <span>
                <v-icon class="px-1" v-if="!item.editing" @click="editProfanity(item)" color="primary">mdi-pencil</v-icon>
                <v-icon class="px-1" v-if="item.editing" @click="saveProfanity(item)" color="primary">mdi-content-save</v-icon>
                <v-icon class="px-1" @click="deleteProfanity(item)" color="primary">mdi-trash-can</v-icon>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-5 pb-5">
          <v-btn width="125" color="secondary" @click="dialog = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>